import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PainAgitation() {
  return <section className="px-6 py-8 max-w-3xl mx-auto" data-id="element-162">
      <FadeIn data-id="element-163">
        <div className="space-y-5 text-lg md:text-xl leading-relaxed text-[#2D2A26]" data-id="element-164">
          <p data-id="element-165">
            Nadie te lo dice directamente, pero lo que estás viviendo tiene un
            nombre científico:
          </p>

          <p className="font-bold text-2xl text-[#9B4F2B] my-6 border-l-4 border-[#9B4F2B] pl-6 py-2" data-id="element-166">
            Tu sistema nervioso está atascado en modo de emergencia permanente.
          </p>

          <p data-id="element-167">No porque estés exagerada.</p>
          <p data-id="element-168">No porque seas "muy sensible".</p>
          <p data-id="element-169">No porque "así eres tú".</p>

          <p data-id="element-170">
            Sino porque llevas meses — quizás años — procesando el estrés de tu
            vida, tu trabajo, tus relaciones, tus responsabilidades... muchas
            veces en silencio, muchas veces sola.
          </p>

          <p data-id="element-171">
            Y un sistema nervioso en alerta constante no puede distinguir entre
            un peligro real y una lista de tareas pendientes.
          </p>

          <p className="font-bold text-[#4A5D3A]" data-id="element-172">
            Para tu cerebro, todo es una emergencia.
          </p>

          <div className="bg-white/50 p-6 rounded-2xl shadow-sm my-6 space-y-3 border border-[#4A5D3A]/10" data-id="element-173">
            <p data-id="element-174">
              Por eso no puedes "simplemente relajarte" cuando alguien te lo
              dice.
            </p>
            <p data-id="element-175">Por eso el yoga duró tres semanas.</p>
            <p data-id="element-176">
              Por eso el té de manzanilla del supermercado no hizo absolutamente
              nada.
            </p>
            <p data-id="element-177">
              Por eso te despiertas a las 3 AM con el corazón acelerado sin
              saber por qué.
            </p>
            <p data-id="element-178">
              Por eso llegas al final del día completamente vacía, pero no
              puedes dormir.
            </p>
          </div>

          <p data-id="element-179">Esto no es un defecto de carácter.</p>

          <p className="font-bold text-2xl md:text-3xl text-[#4A5D3A] text-center mt-8" data-id="element-180">
            Es biología. Y la biología tiene solución.
          </p>

          <img src="https://cdn.magicpatterns.com/uploads/9NNvcLwqAW9j1rt6BAU67F/imagen_3_para_la_pagina_de_venta.png" alt="Cerebro botánico — la biología tiene solución" className="w-full max-w-md mx-auto rounded-2xl shadow-lg mt-6" data-id="element-181" />
        </div>
      </FadeIn>
    </section>;
}